<style>
.center {
  margin: 20px 0 0 20px;
}
</style>

<template>
  <div class="app-container">
    <ut-form inline class="center">
      <ut-form-item label="账号" index="git">
        <ut-input v-model="account"></ut-input>
      </ut-form-item>
      <ut-form-item label="姓名" index="git">
        <ut-input v-model="name"></ut-input>
      </ut-form-item>
      <ut-form-item>
        <ut-button type="primary" @click="search">查询</ut-button>
      </ut-form-item>
      <ut-form-item>
        <ut-button type="primary" @click="transferPermission"
          >权限转移</ut-button
        >
      </ut-form-item>
    </ut-form>

    <ut-table :source="dataSource" border>
      <ut-table-column title="账号" key="account" index="account" />
      <ut-table-column title="姓名" key="name" index="name" />
      <ut-table-column title="邮箱地址" key="email" index="email" />
      <ut-table-column title="手机号" key="phone" index="phone" />

      <ut-table-column title="操作" inline-template>
        <div>
          <ut-button
            type="info"
            size="small"
            @click.native="edit($index, row)"
            :style="{ marginLeft: '5px' }"
            >修改</ut-button
          >
          <ut-popconfirm
            @confirm="deleteRow(row)"
            title="你确定要删除此人员吗？"
          >
            <ut-button type="danger" size="small" :style="{ marginLeft: '5px' }"
              >删除</ut-button
            >
          </ut-popconfirm>
          <ut-button
            type="success"
            size="small"
            @click.native="permissionQuery($index, row)"
            :style="{ marginLeft: '5px' }"
            >权限查询</ut-button
          >
        </div>
      </ut-table-column>
    </ut-table>
    <ut-pagination
      :style="{
        marginLeft: '50%',
        transform: 'translateX(-50%)',
        marginTop: '20px'
      }"
      :total="pageInfo.totalCount"
      :current="pageNo"
      @change="changePager"
      :page-size="20"
    ></ut-pagination>
  </div>
</template>

<script lang="babel">
export default {
  data () {
    return {
      account: '',
      name: '',
      pageInfo: {
        totalCount: 0
      },
      pageNo: 1,
      dataSource: []
    }
  },
  methods: {
    transferPermission () {
      this.$router.push({ path: '/users/transfer' })
    },
    edit (idx, row) {
      var json = {
        path: '/users/edit',
        query: {
          account: row.account
        }
      }
      this.$router.push(json)
    },
    permissionQuery (idx, row) {
      var json = {
        path: '/users/query',
        query: {
          account: row.account
        }
      }
      this.$router.push(json)
    },
    deleteRow (row) {
      this.$http({
        method: 'post',
        url: 'users/' + row.account + '/remove.htm'
      }).then(({ data }) => {
        console.log('data: ', data)
        if (+data.code === 0 && +data.result === 0) {
          this.$message.success('删除成功')
          this.search()
        } else {
          this.$message.error('用户还有权限未转移,禁止删除!')
        }
      }).catch(error => {
        console.log(error) // 请求失败返回的数据
      })
    },
    formatLevel (level) {
      switch (level) {
        case 0: {
          return '2'
        }
        case 1: {
          return 'primary'
        }
        case 2: {
          return 'success'
        }
        case 3: {
          return 'warning'
        }
        case 4: {
          return 'danger'
        }
      }
    },
    changePager (page) {
      if (page == 0) {
        return
      }
      var sendData = {}

      if (this.account != undefined && this.account != '') {
        sendData.account = this.account
      }
      if (this.name != '') {
        sendData.name = this.name
      }

      sendData.pageNo = page

      console.log(sendData)
      var sendJson = JSON.stringify(sendData)

      this.$http({
        method: 'post',
        url: 'users/query.htm',
        data: sendJson
      })
        .then(response => {
          this.$message.info(`当前切换到第${page}页`)
          // 这里使用了ES6的语法
          console.log(response) // 请求成功返回的数据
          this.pageNo = page
          this.dataSource = response.data.dataList
        })
        .catch(error => {
          console.log('请求是啊吧 ' + error) // 请求失败返回的数据
        })
    },
    search () {
      var sendData = {}

      if (this.account != undefined && this.account != '') {
        sendData.account = this.account
      }
      if (this.name != undefined && this.name != '') {
        sendData.name = this.name
      }
      if (sendData.account == undefined || sendData.account == '') {
        sendData.account = sendData.name
      }
      if (sendData.name == undefined || sendData.name == '') {
        sendData.name = sendData.account
      }
      console.log('sendData:', sendData)
      if (this.pageNo == undefined) {
        sendData.pageNo = 0
      } else {
        sendData.pageNo = 1
      }
      console.log(sendData)
      var sendJson = JSON.stringify(sendData)
      console.log(sendJson)
      this.$http({
        method: 'post',
        url: 'users/query.htm',
        data: sendJson
      })
        .then(response => {
        // 这里使用了ES6的语法
          if (response === undefined) {
            console.log('没有返回数据')
            this.$message.info(`系统异常跳回登录`)
            this.$router.push({ path: '/login' })
          }
          this.dataSource = response.data.dataList
          this.pageInfo.totalCount = response.data.totalCount
          this.pageNo = response.data.totalPageCount > 0 ? 1 : 0
          this.$message.info(`当前切换到第${this.pageNo}页`)
        })
        .catch(error => {
          console.log(error) // 请求失败返回的数据
        })
    }
  },
  created () {
    const { allPermiList } = this.$store.getters
    // eslint-disable-next-line no-undef
    const sysKey = BUILD_ENV === 'ali' ? 'argus-ali-users' : 'argus-users'
    if (!allPermiList.includes(sysKey)) {
      this.$router.push('/401')
    }

    this.$http({
      method: 'post',
      url: 'users/query.htm',
      data: '{}'
    })
      .then(response => {
        // 这里使用了ES6的语法
        this.dataSource = response.data.dataList
        this.pageInfo.totalCount = response.data.totalCount
      })
      .catch(error => {
        console.log(error) // 请求失败返回的数据
      })
  },
  filters: {
    setStr (s) {
      return s.owners.map(item => item.name).join(',')
    }
  }
}
</script>
